import { render, staticRenderFns } from "./ExtendedBtnMenu.vue?vue&type=template&id=5185b902&scoped=true&"
import script from "./ExtendedBtnMenu.vue?vue&type=script&lang=js&"
export * from "./ExtendedBtnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5185b902",
  null
  
)

export default component.exports